import { ListRecipesQueryVariables } from '@akin-home/amplify';
import { filterHasValue } from '@akin-home/arrays';
import {
  listRecipesQuery,
  recipeGraphqlToModel,
} from '@akin-home/recipes-front-end';
import { useMemo } from 'react';
import { useInfiniteQuery } from 'react-query';
import { recipesQueryKey } from './query_key';

/** Provides recipes in a paged format */
export const useListRecipes = (params?: {
  params?: ListRecipesQueryVariables;
  options?: any;
}) =>
  useInfiniteQuery(
    recipesQueryKey.pages(params?.params),
    ({ pageParam }) =>
      listRecipesQuery({ ...params?.params, nextToken: pageParam }),
    {
      ...params?.options,
      getNextPageParam: (res) => res.data.listRecipes?.nextToken,
    }
  );

export const useListRecipeModels = (params?: {
  params?: ListRecipesQueryVariables;
  options?: any;
}) => {
  const { data, ...result } = useListRecipes(params);

  /** Get a flat list of the recipes */
  const recipes = useMemo(
    () =>
      data?.pages.flatMap(
        ({ data }) =>
          filterHasValue(data.listRecipes?.items).map((d) =>
            recipeGraphqlToModel(d as any)
          ) || []
      ) || [],
    [data?.pages]
  );

  return {
    ...result,
    recipes,
  };
};
